import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';

let userObject = {
    id: null,
    abbr: null,
    lastname: null,
    firstname: null,
    birthday: null,
    country_id: null,
    phone: null,
    name: null,
    email: null,
    token: null,

    showLogin: false,
    showSignUp: false,
    forgotPassword: false,
}


const {get, set, update, subscribe} = writable(userObject);

const user = {
    set,
    update,
    subscribe,

    getToken: () => {
        return userObject.token || '';
    },

    acronym: () => {
        if (!userObject.name) {
            return '';
        }
        return userObject.name.split(' ').map(function (item) {
            return item[0]
        }).join('');
    },

    initialize: () => {
        user.update(obj => {
            obj.token = cookie.get('enorme-loyalty') || null;
            return obj;
        });
    },

    setUser: data => {
        user.update(obj => {
            obj.id = data.id;
            obj.hash = data.hash;
            obj.code = data.code;
            obj.abbr = data.abbr;
            obj.lastname = data.lastname;
            obj.firstname = data.firstname;
            obj.birthday = data.birthday;
            obj.country_id = data.country_id;
            obj.phone = data.phone;
            obj.email = data.email;
            obj.name = data.lastname + ' ' + data.firstname;
            obj.teatro_pass_expire_at = data.teatro_pass_expire_at;
            obj.token = data.token;
            obj.has_teatro_pass = false;
            if (data.teatro_pass_expire_at) {
                obj.has_teatro_pass = new Date() <= new Date(data.teatro_pass_expire_at);
            }

            user.saveCookie();
            return obj;
        });
    },

    clearToken: () => {
        user.update(obj => {
            obj.token = null;
            user.saveCookie();
            return obj;
        });
    },

    saveCookie: () => {
        if (userObject.token) {
            cookie.create('enorme-loyalty', userObject.token);
        } else {
            cookie.delete('enorme-loyalty');
        }
    },

    deleteCookie: () => {
        cookie.delete('enorme-loyalty');
    },

    showLogin: () => {
        user.update(obj => {
            obj.showLogin = true;
            obj.showSignUp = false;
            obj.forgotPassword = false;
            return obj;
        });
    },
    hideLogin: () => {
        user.update(obj => {
            obj.showLogin = false;
            return obj;
        });
    },
    showForgotPassword: () => {
        user.update(obj => {
            obj.showLogin = false;
            obj.showSignUp = false;
            obj.forgotPassword = true;
            return obj;
        });
    },
    hideForgotPassword: () => {
        user.update(obj => {
            obj.forgotPassword = false;
            return obj;
        });
    },
    showSignUp: () => {
        user.update(obj => {
            obj.showLogin = false;
            obj.showSignUp = true;
            obj.forgotPassword = false;
            return obj;
        });
    },
    hideSignUp: () => {
        user.update(obj => {
            obj.showSignUp = false;
            return obj;
        });
    },
}

export default user;